import React from 'react'

const TabContext = React.createContext()

export default TabContext
